"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M15.89 14.56l-4.99-10h-.01c-.17-.33-.5-.56-.89-.56s-.72.23-.89.56H9.1l-5 10h.01c-.06.13-.11.28-.11.44 0 .55.45 1 1 1h10c.55 0 1-.45 1-1 0-.16-.05-.31-.11-.44z"];
//# sourceMappingURL=symbol-triangle-up.js.map